var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interest-links p-2 p-xl-4"},[_c('h5',[_vm._v("Enlaces de interés")]),_c('ul',_vm._l((_vm.currentEpisodeLinks),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_vm._v(_vm._s(item.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }